import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter, Redirect } from 'react-router';

import Logo from '../images/logo.png';
import Account from '../images/Account.png';

import { connect } from 'react-redux';

import Notification from './Notification';

import '../scss/layout/_header.scss';

import {
  logoutSuccess,
} from '../store/action';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      title: '首頁',
      adminName: localStorage.getItem('adminName') || "張仲豪",
      isShowInformation: false,
    }
    this.toggleInformation = this.toggleInformation.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      adminName: nextProps.loginState.adminName
    })
  }

  toggleInformation() {
    this.setState({
      isShowInformation: !this.state.isShowInformation
    })
  }
  changeStore() {
    localStorage.removeItem('current_store_id')
  }

  render() {
    let { loginState } = this.props;
    let { adminName, isShowInformation, notificationArray } = this.state;
    if(!localStorage.getItem('current_store_id')){
    　　return <Redirect to='/store' />
    }
    return (
      <div className="l-header fadeIn" style={{display: loginState.isLogin && localStorage.getItem('current_store_id') ? 'flex' : 'none'}}>
        <div className="l-header__logo" style={{ backgroundColor: (localStorage.getItem('current_store_id') === '2'||localStorage.getItem('current_store_id') === '3') ?'#183082':''}}>
          <NavLink exact to='/~' activeClassName="active">
            <img src={Logo} width="100%" alt='' />
          </NavLink>
        </div>
        <div className="l-header__information" style={{display: loginState.isLogin && localStorage.getItem('current_store_id')? 'flex' : 'none'}}>
          <label htmlFor={"toggle-menu"} className="l-header__information__hambarger"><div className="bar"></div></label>
          <div className="l-header__information__tools" onClick={this.toggleInformation}>
            <div className="account">
              <img src={Account} alt='' />
              <Notification isShowInformation={isShowInformation} 
                adminName={adminName} 
                logoutSuccessFunc={this.props.logoutSuccess}
                changeStore={this.changeStore}
                notificationArray={notificationArray} 
                removeNotification={this.handleRemoveNotification}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  loginState: store.loginState,
})

export default connect(mapStateToProps,{
  logoutSuccess
},null,{pure: false})(withRouter(Header));